import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group d-flex flex-wrap" }
const _hoisted_23 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group d-flex flex-wrap" }
const _hoisted_26 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "form-group d-flex flex-wrap" }
const _hoisted_34 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-group d-flex flex-wrap" }
const _hoisted_39 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("自动")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("手动")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("混合")
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group d-flex flex-wrap" }
const _hoisted_46 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group d-flex flex-wrap" }
const _hoisted_49 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group d-flex flex-wrap" }
const _hoisted_52 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_55 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_56 = { class: "indicator-label" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_58 = { class: "indicator-progress" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_60 = { class: "card mb-5 mb-xl-10" }
const _hoisted_61 = { class: "card-header" }
const _hoisted_62 = { class: "card-title m-0" }
const _hoisted_63 = { class: "fw-boldest m-0" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_66 = { class: "card-body p-9 pb-0" }
const _hoisted_67 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_68 = {
  key: 1,
  class: "badge badge-light-warning"
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "svg-icon svg-icon-3" }
const _hoisted_71 = { class: "svg-icon svg-icon-3" }
const _hoisted_72 = { class: "card mb-5 mb-xl-10" }
const _hoisted_73 = { class: "card-header" }
const _hoisted_74 = { class: "card-title m-0" }
const _hoisted_75 = { class: "fw-boldest m-0" }
const _hoisted_76 = { class: "card-body p-9 pb-0" }
const _hoisted_77 = { class: "svg-icon svg-icon-3" }
const _hoisted_78 = { class: "card mb-5 mb-xl-10" }
const _hoisted_79 = { class: "card-header" }
const _hoisted_80 = { class: "card-title m-0" }
const _hoisted_81 = { class: "fw-boldest m-0" }
const _hoisted_82 = { class: "card-body p-9 pb-0" }
const _hoisted_83 = { class: "mb-5" }
const _hoisted_84 = { class: "svg-icon svg-icon-3" }
const _hoisted_85 = { class: "mb-5" }
const _hoisted_86 = { class: "svg-icon svg-icon-3" }
const _hoisted_87 = { class: "card mb-5 mb-xl-10" }
const _hoisted_88 = { class: "card-header border-0" }
const _hoisted_89 = { class: "card-title m-0" }
const _hoisted_90 = { class: "fw-boldest m-0" }
const _hoisted_91 = { class: "card-body border-top p-9" }
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-md-6" }
const _hoisted_94 = { class: "form-group d-flex flex-wrap" }
const _hoisted_95 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_96 = { class: "el-form-item__content" }
const _hoisted_97 = { class: "col-md-6" }
const _hoisted_98 = { class: "form-group d-flex flex-wrap" }
const _hoisted_99 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_100 = { class: "el-form-item__content" }
const _hoisted_101 = { class: "col-md-6" }
const _hoisted_102 = { class: "form-group d-flex flex-wrap" }
const _hoisted_103 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_104 = { class: "el-form-item__content" }
const _hoisted_105 = { class: "col-md-6" }
const _hoisted_106 = { class: "form-group d-flex flex-wrap" }
const _hoisted_107 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_108 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_ELDatatable = _resolveComponent("ELDatatable")!
  const _component_AddCampaignMemberModel = _resolveComponent("AddCampaignMemberModel")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("marketingCampaigns.information")), 1)
        ])
      ]),
      _createVNode(_component_el_form, {
        onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.formData,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("marketingCampaigns.campaignName")), 1),
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("marketingCampaigns.status")), 1),
                  _createVNode(_component_el_form_item, { prop: "status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.status) = $event)),
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.t('marketingCampaigns.plan'),
                            value: 10
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('marketingCampaigns.processing'),
                            value: 20
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('marketingCampaigns.completed'),
                            value: 30
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('marketingCampaigns.void'),
                            value: 40
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("marketingCampaigns.parentCampaign")), 1),
                  _createVNode(_component_el_form_item, { prop: "parent_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.parent_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.parent_id) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.campaignLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value,
                              style: {"width":"100%"}
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("marketingCampaigns.campaignPurpose")), 1),
                  _createVNode(_component_el_form_item, { prop: "purpose" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.purpose,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.purpose) = $event)),
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignPurposeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value,
                              style: {"width":"100%"}
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("marketingCampaigns.campaignType")), 1),
                  _createVNode(_component_el_form_item, { prop: "type" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.type,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.type) = $event)),
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignTypeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value,
                              style: {"width":"100%"}
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("marketingCampaigns.startDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "start_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.start_date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.start_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'start_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("marketingCampaigns.endDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "end_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.end_date,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.end_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'end_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("marketingCampaigns.description")), 1),
                  _createVNode(_component_el_form_item, { prop: "description" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.description,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.description) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("marketingCampaigns.coverageSelection")), 1),
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.t("marketingCampaigns.selectionMode")), 1),
                  _createVNode(_component_el_form_item, { prop: "selection_mode" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.formData.selection_mode,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.selection_mode) = $event)),
                        size: "mini",
                        disabled: 
                    _ctx.options.campaignMemberLoading ||
                    _ctx.options.salesInteractionLoading ||
                    _ctx.isEndDate
                  
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: 10 }, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 20 }, {
                            default: _withCtx(() => [
                              _hoisted_41
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 30 }, {
                            default: _withCtx(() => [
                              _hoisted_42
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t("marketingCampaigns.mbSegmentation")), 1),
                    _createVNode(_component_el_form_item, { prop: "mb_segmentation" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.mb_segmentation,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.mb_segmentation) = $event)),
                          clearable: "",
                          multiple: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"},
                          autocomplete: "off",
                          disabled: _ctx.isEndDate
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "option1",
                              value: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: "option2",
                              value: 2
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.t("marketingCampaigns.dedicatedGroupLevel")), 1),
                    _createVNode(_component_el_form_item, { prop: "dedicated_group_level" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.dedicated_group_level,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.dedicated_group_level) = $event)),
                          clearable: "",
                          multiple: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          loading: _ctx.dedicatedGroupLevelLoading,
                          style: {"width":"100%"},
                          autocomplete: "off",
                          disabled: _ctx.isEndDate
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dedicatedGroupLevelOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value,
                                style: {"width":"100%"}
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "loading", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.t("marketingCampaigns.coverageScope")), 1),
                    _createVNode(_component_el_form_item, { prop: _ctx.coverage_scope }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: _ctx.formData.coverage_scope,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.coverage_scope) = $event)),
                          disabled: _ctx.isEndDate
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, { label: "1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("influencerAccount.account")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("influencerAccount.lead")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["prop"])
                  ])
                ])
              ])
            ], 512), [
              [_vShow, 
            _ctx.formData.selection_mode !== 20 &&
            _ctx.formData.selection_mode !== 0 &&
            _ctx.formData.selection_mode !== 1 &&
            _ctx.formData.selection_mode !== 2
          ]
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_router_link, {
              to: '/interactive-marketing/marketing-campaigns/',
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_54,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_55, [
              _createElementVNode("span", _hoisted_56, [
                _hoisted_57,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_58, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_59
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("h3", _hoisted_63, _toDisplayString(_ctx.t("marketingCampaigns.campaignMembers")), 1),
          _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
            default: _withCtx(() => [
              (
              _ctx.options.defaultSelectionMode !== 10 &&
              _ctx.options.defaultSelectionMode !== 0 &&
              _ctx.options.defaultSelectionMode !== 1 &&
              _ctx.options.defaultSelectionMode !== 2
            )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modal_add_campaign_member",
                    title: "Add",
                    class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
                    disabled: _ctx.options.campaignMemberLoading || _ctx.isEndDate
                  }, [
                    _createElementVNode("span", _hoisted_65, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                    ])
                  ], 8, _hoisted_64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_66, [
        _createVNode(_component_ELDatatable, {
          loading: _ctx.options.campaignMemberLoading,
          "table-columns": _ctx.options.campaignMemberColumns,
          "table-data": _ctx.options.campaignMemberList,
          "current-page": _ctx.options.campaignMemberCurrentPage,
          total: _ctx.options.campaignMemberTotal,
          "rows-per-page": _ctx.options.campaignMemberPageSize,
          onCurrentChange: _ctx.handleCampaignMemberCurrentChange,
          onItemsPerPageChange: _ctx.setCampaignMemberPerPage
        }, {
          type: _withCtx(({ row }) => [
            (row.type == 'Accounts')
              ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.t("influencerAccount.account")), 1))
              : (row.type == 'Leads')
                ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.t("influencerAccount.lead")), 1))
                : _createCommentVNode("", true)
          ]),
          actions: _withCtx(({ row }) => [
            _withDirectives(_createElementVNode("button", {
              type: "button",
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2",
              onClick: ($event: any) => (_ctx.handleDeleteCampaignMemberModel(row))
            }, [
              _createElementVNode("span", _hoisted_70, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
              ])
            ], 8, _hoisted_69), [
              [_vShow, row.__can_delete]
            ]),
            _createVNode(_component_router_link, {
              to: 
              (row.type == 'Leads'
                ? '/interactive-marketing/account-conversions/'
                : '/influencer-platform/influencer-accounts/') +
              row.id +
              '/information'
            ,
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_71, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createElementVNode("div", _hoisted_72, [
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("h3", _hoisted_75, _toDisplayString(_ctx.t("marketingCampaigns.influencedSalesInteractions")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_76, [
        _createVNode(_component_ELDatatable, {
          loading: _ctx.options.salesInteractionLoading,
          "table-columns": _ctx.options.salesInteractionColumns,
          "table-data": _ctx.options.salesInteractionList,
          "current-page": _ctx.options.salesInteractionCurrentPage,
          total: _ctx.options.salesInteractionTotal,
          "rows-per-page": _ctx.options.salesInteractionPageSize,
          onCurrentChange: _ctx.handleSalesInteractionCurrentChange,
          onItemsPerPageChange: _ctx.setSalesInteractionPerPage
        }, {
          start_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.start_date)), 1)
          ]),
          end_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.end_date)), 1)
          ]),
          actions: _withCtx(({ row }) => [
            _createVNode(_component_router_link, {
              to: 
              '/interactive-marketing/interactive-activities/' +
              row.id +
              '/information'
            ,
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_77, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createElementVNode("div", _hoisted_78, [
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("h3", _hoisted_81, _toDisplayString(_ctx.t("marketingCampaigns.relatedTasks")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_82, [
        _createElementVNode("h4", _hoisted_83, _toDisplayString(_ctx.t("influencerAccount.callOut")), 1),
        _createVNode(_component_ELDatatable, {
          loading: _ctx.options.callOutLoading,
          "table-columns": _ctx.options.callOutColumns,
          "table-data": _ctx.options.callOutList,
          "current-page": _ctx.options.callOutCurrentPage,
          total: _ctx.options.callOutTotal,
          "rows-per-page": _ctx.options.callOutPageSize,
          onCurrentChange: _ctx.handleCallOutCurrentChange,
          onItemsPerPageChange: _ctx.setCallOutPerPage
        }, {
          due_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.due_date)), 1)
          ]),
          action_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.action_date)), 1)
          ]),
          actions: _withCtx(({ row }) => [
            _createVNode(_component_router_link, {
              to: '/task-management/call-out-records/' + row.id + '/information',
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_84, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"]),
        _createElementVNode("h4", _hoisted_85, _toDisplayString(_ctx.t("influencerAccount.quickInquiry")), 1),
        _createVNode(_component_ELDatatable, {
          loading: _ctx.options.quickInquiryLoading,
          "table-columns": _ctx.options.quickInquiryColumns,
          "table-data": _ctx.options.quickInquiryList,
          "current-page": _ctx.options.quickInquiryCurrentPage,
          total: _ctx.options.quickInquiryTotal,
          "rows-per-page": _ctx.options.quickInquiryPageSize,
          onCurrentChange: _ctx.handleQuickInquiryCurrentChange,
          onItemsPerPageChange: _ctx.setQuickInquiryPerPage
        }, {
          request_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.request_date)), 1)
          ]),
          actions: _withCtx(({ row }) => [
            _createVNode(_component_router_link, {
              to: '/task-management/quick-inquiry/' + row.id + '/information',
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_86, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createElementVNode("div", _hoisted_87, [
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("h3", _hoisted_90, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_91, [
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_96, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_100, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_108, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_AddCampaignMemberModel, {
      id: _ctx.modelId,
      "parent-id": parseInt(_ctx.$route.params.id),
      onUpdateList: _ctx.updateModelList,
      onResetForm: _ctx.handleAddModel
    }, null, 8, ["id", "parent-id", "onUpdateList", "onResetForm"])
  ], 64))
}